<template>
  <div class="col-md-4">
    <div class="x_panel">
      <div class="x_content">
        <div class="row">
          <div class="col-md-6">
            <h4 class="black-word fontSize20">選擇呼號/隊編位置</h4>
            <select
              id="heard"
              class="form-control fontSize16"
              v-model="driverAccount"
              @change="onCallNumber(driverAccount)"
              required=""
            >
              <option value="">呼號/隊編 - 姓名</option>
              <option
                v-for="driver in vx_driverOptions"
                :key="driver.phone"
                :value="driver.phone"
              >
                {{ driver.call_number }} - {{ driver.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <input
              type="number"
              required="required"
              class="inputstyle col-md-5 fontSize16"
              placeholder="輸入呼號"
              v-model="callNumber"
            />
            <button
              type="button"
              class="mybtnstyle btn-success"
              @click="onSearchCallNumber"
              :disabled="isDataLoading || isSearching"
            >
              <span v-if="isDataLoading">載入中...</span>
              <span v-else-if="isSearching">搜尋中...</span>
              <span v-else>搜尋</span>
            </button>
            <button
              type="button"
              class="mybtnstyle btn-danger"
              @click="onClearCallNumber"
            >
              取消追蹤
            </button>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <AddrAutoComplete
              class="col-md-12"
              v-model="inputAddr"
              @getSelectedAddr="getSelectedAddr"
            />
            <button
              type="button"
              class="mybtnstyle btn-success"
              @click="$emit('setAutoLocationMarker')"
            >
              地址搜尋
            </button>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <button
              type="button"
              class="mybtnstyle btn-primary"
              @click="$emit('onDownloadKml')"
            >
              重新下載派遣排班區
            </button>
          </div>
          <div class="col-md-6">
            <button
              type="button"
              class="mybtnstyle btn-warning"
              style="color: #000000"
              @click="$router.push({ name: 'driverDistribution' })"
            >
              歷史車輛分佈圖
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { reqDriverInfo } from '@/api/driverMonitor'
import AddrAutoComplete from '@/components/tool/AddrAutoComplete'
import { Notification } from 'element-ui'
import { options } from '@/constants/driverMonitor'
import { formatCarYear } from '@/utils/helper'
import dayjs from 'dayjs'
import { cookies } from '@/utils/cookies'

export default {
  name: 'Form',
  components: {
    AddrAutoComplete,
  },
  data() {
    return {
      driverAccount: '',
      callNumber: '',
      inputAddr: '',
      isSearching: false,
    }
  },
  methods: {
    ...mapActions('driverMonitor', {
      vx_fetchDriverTabAddr: 'fetchDriverTabAddr',
    }),
    ...mapMutations('driverMonitor', {
      vx_setDriverInfo: 'setDriverInfo',
      vx_setAutoLocation: 'setAutoLocation',
      vx_setMapCenter: 'setMapCenter',
      vx_setIsTrack: 'setIsTrack',
      vx_setActiveTab: 'setActiveTab',
      vx_initDriverInfo: 'initDriverInfo',
      vx_initDriverTabAddr: 'initDriverTabAddr',
    }),
    async onCallNumber() {
      this.vx_setMapCenter({ lat: null, lng: null })
      this.vx_setIsTrack(false)
      /* 找尋司機資料 */
      const targetDriver = this.vx_driverOptions.find(
        ({ phone }) => phone === this.driverAccount,
      )
      if (targetDriver) {
        this.callNumber = targetDriver.call_number
        try {
          const { info } = await reqDriverInfo({
            account: this.driverAccount,
          })
          if (info === '找不到此司機' || !info) {
            Notification({
              message: '找不到此司機',
              type: 'warning',
            })
          } else {
            const driverLocation = this.vx_driverLocations.find(
              ({ account }) => account === this.driverAccount,
            )
            if (driverLocation) {
              const driverInfo = {
                id: info.id,
                call_number: info.call_number,
                account: info.account,
                licence: info.licence,
                car_year: formatCarYear(info.car_year),
                name: info.name,
                car_brand: info.car_brand,
                availableSeat: info.available_seat,
                note: info.note,
                service_list: info.service_list,
                contact1: info.contact1,
                contact2: info.contact2,
                updated_at: dayjs(info.updated_at).format(
                  'YYYY-MM-DD HH:mm:ss',
                ),
                status: driverLocation.statusName,
                gender: driverLocation.gender,
                lat: driverLocation.lat,
                lng: driverLocation.lng,
                team_company_note: info.team_company_note,
              }
              this.vx_setDriverInfo(driverInfo)
              this.$emit('followSpecificDriver')
              this.vx_setIsTrack(true)
            } else {
              const driverInfo = {
                id: info.id,
                call_number: info.call_number,
                account: info.account,
                licence: info.licence,
                car_year: formatCarYear(info.car_year),
                name: info.name,
                car_brand: info.car_brand,
                note: info.note,
                service_list: info.service_list,
                contact1: info.contact1,
                contact2: info.contact2,
                updated_at: dayjs(info.updated_at).format(
                  'YYYY-MM-DD HH:mm:ss',
                ),
                status: '',
                gender: '',
                lat: null,
                lng: null,
              }
              this.vx_setDriverInfo(driverInfo)
            }
            this.vx_setActiveTab('driver')
          }
        } catch (e) {
          console.error(e)
        }
      }
    },
    async onSearchCallNumber() {
      // 防止重複點擊
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      try {
        if (this.callNumber && this.callNumber !== '') {
          // 嘗試多種比對方式
          const targetDriver1 = this.vx_driverOptions.find(
            (driver) => driver.call_number === this.callNumber,
          )
          const targetDriver2 = this.vx_driverOptions.find(
            (driver) => String(driver.call_number) === String(this.callNumber),
          )
          const targetDriver3 = this.vx_driverOptions.find(
            (driver) => driver.call_number == this.callNumber,
          )

          const targetDriver = targetDriver1 || targetDriver2 || targetDriver3

          if (targetDriver) {
            this.driverAccount = targetDriver.phone
            await this.onCallNumber()
          } else {
            Notification({
              message: '查無此司機',
              type: 'warning',
            })
          }
        } else {
          Notification({
            message: '請輸入正確的呼號',
            type: 'warning',
          })
        }
      } catch (error) {
        console.error('搜尋過程中發生錯誤:', error)
        Notification({
          message: '搜尋過程中發生錯誤，請稍後再試',
          type: 'error',
        })
      } finally {
        this.isSearching = false
      }
    },
    onClearCallNumber() {
      this.driverAccount = ''
      this.callNumber = ''
      this.vx_setMapCenter({
        lat: null,
        lng: null,
      })
      this.$emit('setDriverMarkerClear')
      this.vx_initDriverInfo()
      this.vx_initDriverTabAddr()
      this.vx_setIsTrack(false)
    },
    getSelectedAddr({ longitude, latitude }) {
      this.vx_setAutoLocation({
        longitude,
        latitude,
      })
    },
  },
  computed: {
    ...mapState('driverMonitor', {
      vx_driverOptions: 'driverOptions',
      vx_driverLocations: 'driverLocations',
      vx_driverInfo: 'driverInfo',
      vx_mapCenter: 'mapCenter',
      vx_isDriverOptionsLoading: 'isDriverOptionsLoading',
    }),
    // 檢查資料是否已載入完成
    isDataLoading() {
      return this.vx_isDriverOptionsLoading
    },
  },
  created() {
    this.OPTIONS = options
  },
  mounted() {
    this.inputAddr = cookies.get('GladArea')
    if (this.vx_driverInfo.account !== '') {
      this.driverAccount = this.vx_driverInfo.account
      this.onCallNumber()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/driver/driver-monitor-components-v2/Form.vue